import { Box, Typography } from '@mui/material';

export const EmptySection = ({ label }: { label: string }) => (
  <Box sx={{ py: 4, textAlign: 'center' }}>
    <Typography variant="body2" color="text.secondary">
      No {label.toLowerCase()} found in template.
    </Typography>
  </Box>
);
